import { FormError } from '../errors';
import { type JsmErrorResponseDto } from '../types';

export const mapJsmErrorResponseDtoToFormError = (error: JsmErrorResponseDto): FormError => {
  // from an error message like "Required field Business Unit with id customfield_10056 cannot be empty" pick up a field name
  const regex = / with id ([\d_a-z]+) /;
  const matches = error.friendlyReason.body.match(regex);
  const fieldName = matches && matches.length > 1 ? matches[1] : null;
  const message = error.friendlyReason.body.replace(regex, ' ');

  return new FormError(message, fieldName);
};
